module.exports = __webpack_public_path__ + "img/audi-ic.b2576bf7.svg";